import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import SeriesList from "./pages/SeriesList";
import SeriesDetail from "./pages/SeriesDetail";
import ViralVideos from "./pages/ViralVideos";
import AICreative from "./pages/AICreative";
import ComingSoon from "./pages/ComingSoon";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Search from "./pages/Search";
import Watch from "./pages/Watch";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { AuthProvider } from "./context/AuthContext";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
    return null;
}

function App() {
    return (
        <div className="App min-h-screen bg-[#0B0B0B] text-white font-sans">
            <BrowserRouter>
                <AuthProvider>
                    <ScrollToTop />
                    <Navbar />
                    <main>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/series" element={<SeriesList />} />
                            <Route path="/series/:id" element={<SeriesDetail />} />
                            <Route path="/viral" element={<ViralVideos />} />
                            <Route path="/ai-creative" element={<AICreative />} />
                            <Route path="/coming-soon" element={<ComingSoon />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route path="/terms" element={<Terms />} />
                            <Route path="/search" element={<Search />} />
                            <Route path="/watch/:kind/:id" element={<Watch />} />
                            <Route path="/watch/episode/:seriesId/:id" element={<Watch />} />
                            <Route path="/admin" element={<AdminLogin />} />
                            <Route path="/admin/dashboard" element={<AdminDashboard />} />
                        </Routes>
                    </main>
                    <Footer />
                    <Toaster theme="dark" position="top-right" richColors />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
